import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';

export default function Thithe() {

    return (
        <div>
            <NavBar/>
            <Title text={"Sobre o Dízimo, o que é?"}/>

            <p className="info-text">
            O Dízimo para a Igreja é um gesto de gratidão a Deus por tantos benefícios recebidos. <br/>
            A devolução do dízimo nasce do coração sensível. <br/>
            O dízimo é um ato de amor a Deus e aos irmãos. <br/>
            É uma resposta de fé e de corresponsabilidade pela evangelização, pois a esta tem uma dimensão econômica. <br/>
            A gratidão não tem medida. <br/>
            Cada um é chamado a ser dizimista conscience e generoso. <br/>
            A gratidão e a generosidade são duas atitudes que agradam muito a Deus.<br/>
            "O dízimo é uma contribuição sistemática e periódica dos fiéis, por meio da qual cada comunidade assume, corresponsavelmente, sua sustentação e a da igreja. <br/>
            Ele pressupõe pessoas evangelizadas e comprometidas com a evangelização." (CNBB, Doc. 106, N.6)
            </p> 

            <Title text={"Quem Deve ser Dizimista?"}/>
            <p className="info-text">
            Todas as pessoas que participam da vida da igreja e tem uma fonte de renda são convidadas a serem dizimistas. <br/>
            Ninguém, nessa condição, está dispensado de manifestar sua gratidão a Deus para a promoção da fé.<br/>
            A obrigação dp dízimo vem da generosidade do próprio coração.<br/>
            Se o fiel católico se sente parte integrante da Igreja, então não está dispensado de contribuir para que ela seja sempre viva, forte atuante e tenha todos os meios necessários para que a Palavra de Deus chegue aos mais afastados.<br/>
            O dízimo é a manifestação da consciência da partilha.
            </p>

            <Title text={"O Dízimo na Bíblia"}/>
            <p className="info-text">
            Biblicamente eram dez por cento o que os fiéis judeus davam para a manutenção das despesas do templo e manutenção dos sacerdotes. <br/>
            Com a vinda de Cristo, o dízimo se tornou uma questão de generosidade, não tem medida e deve ser dado de coração:<br/>
            "Dê cada um conforme o impulso do seu coração, sem tristeza nem constangimento. Deus ama quem dá com alegria."<br/>
            É desse modo que Paulo reflete com a comunidade de Corinto (cf. 2Cor 9,7). O importante é que o dizimista se sinta livre e responsável dando fielmente a sua contribuição mental.  
            </p> 

            <Title text={"Onde é Aplicado o Dízimo"}/>
            <p className="info-text">
            <strong>Litúrgica:</strong> Despesas com o culto, objetos litúrgicos, toalhas, velas, ornamentação(flores), vinho, hóstias, data show, livros de canto, etc.<br/>
            <strong>Pastoral:</strong> Promoção das ações evangelizadoras da comunidade paroquial, catequese, retiros, livros, comunicação(cartazes), formações, eventos, feira Bíblica, etc  <br/>
            <strong>Eclesial(Comunitária):</strong> Partilha com a Arquidiocese, manutenção dos sacerdotes, funcionários, manutenção do prédio, da casa paroquial, da secretaria, energia elétrica, água, intertnet, material de limpeza e higiene, etc <br/> 
            <strong>Social (Caritativa):</strong> Promoção humana e social(pobres, idosos, crianças, dependentes químicos), creche pastorais sociais, etc.<br/>
            <strong>Missionária:</strong> Colaboração com as paróquias pobres da Arquidiocese, e de outras Dioceses, ações missionárias na comunidade ou em outros lugares, etc.<br/>
            <strong>Vocacional:</strong> Formação de lideranças, sacerdotes, ministros da eucaristia, catequistas, agentes de pastorais e movimentos, etc.
            </p>
            <Footer/>
        </div>
    )
}